import { Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { fuseAnimations } from "@fuse/animations";
import { ServicioCotizadoDTO } from "app/main/apps/shared/interfaces/servicio-cotizado.interface";
import { CotizacionesService } from "app/main/apps/shared/services/rest/cotizaciones.service";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { DialogAdjuntoComponent } from "../dialog-adjunto/dialog-adjunto.component";

@Component({
    selector: "app-dialog-detalle-servicio",
    templateUrl: "./dialog-detalle-servicio.component.html",
    styleUrls: ["./dialog-detalle-servicio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class DialogDetalleServicioComponent implements OnInit {
    link:SafeResourceUrl;
    name:string;
    @ViewChild('linkHidden') linkHidden: ElementRef<HTMLElement>;
    constructor(
        public dialogRef: MatDialogRef<DialogDetalleServicioComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: ServicioCotizadoDTO,
        private _cotizacionesSrvc: CotizacionesService,
        private _sanitizer: DomSanitizer,
        private _dialogSrvc: DialogService
    ) {}

    ngOnInit(): void {
        
    }

    cerrar(): void {
        this.dialogRef.close();
    }

    verAdjunto(idServicioSolicitudCotizacion: number) {
        this._cotizacionesSrvc
        .fetchArchivoCotizacion(idServicioSolicitudCotizacion)
        .subscribe(blob => {
            const a = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            a.setAttribute('download', 'Servicio_' + idServicioSolicitudCotizacion);
            a.href = url;
            a.click();
      });
    }
}
